module.exports = __webpack_public_path__ + "img/ed-unsplash.3a8d0fd7.png";